import axios from './axios';
import {
  DASHBOARD_NAV,
  SECUREME_NAV_CHILDREN,
  OGA_NAV_CHILDREN,
  OGA_BOIZ_NAV_CHILDREN,
  DEVICE_NAV_CHILDREN,
  CGI_NAV_CHILDREN,
  LOCATE_NOW_NAV_CHILDREN,
  REPORT_NAV_CHILDREN,
  ADMIN_SETTINGS_CHILDREN,
  ACCOUNTANT_PROFILE_NAV,
  LINES_NAV_CHILDREN,
  SMS_MESSAGING_NAV_CHILDREN,
  AUTO_ATTENDANT_NAV_CHILDREN,
  SECURE_DEVICE_NAV_CHILDREN,
  SECURE_ME_ACTIVATION_NAV_CHILDREN,
  OGA_ADMIN_NAV_CHILDREN,
} from '../constants/SideNavs';

const PERMISSION_ROUTE_MAPPING = [
  { permission: 'dashboard', routes: [DASHBOARD_NAV] },
  { permission: 'secure_me', routes: SECUREME_NAV_CHILDREN.concat(SECURE_ME_ACTIVATION_NAV_CHILDREN) },
  { permission: 'oga_app', routes: OGA_NAV_CHILDREN },
  { permission: 'oga_boiz', routes: OGA_BOIZ_NAV_CHILDREN },
  { permission: 'device', routes: DEVICE_NAV_CHILDREN },
  { permission: 'cgi', routes: CGI_NAV_CHILDREN },
  { permission: 'locate_now', routes: LOCATE_NOW_NAV_CHILDREN },
  { permission: 'reports', routes: REPORT_NAV_CHILDREN },
  { permission: 'admin', routes: ADMIN_SETTINGS_CHILDREN.concat(OGA_ADMIN_NAV_CHILDREN) },
  { permission: 'account_profile', routes: [ACCOUNTANT_PROFILE_NAV] },
  { permission: 'lines', routes: LINES_NAV_CHILDREN },
  { permission: 'sms', routes: SMS_MESSAGING_NAV_CHILDREN },
  { permission: 'auto_attendant', routes: AUTO_ATTENDANT_NAV_CHILDREN },
  { permission: 'secure_device', routes: SECURE_DEVICE_NAV_CHILDREN },
];

export const getPermittedRoutes = (permissions) => {
  const routes = [];
  if (!Array.isArray(permissions)) return routes;
  permissions.forEach((permission) => {
    const mapping = PERMISSION_ROUTE_MAPPING.find(
      (item) => item.permission === permission.permissionValue
    );
    if (!mapping) return;
    const options = (permission.options || []).map((option) => option.optionValue);
    mapping.routes.forEach((route) => {
      if (route.to && !route.to.includes(':') && options.includes(route.id)) {
        routes.push(route.to);
      }
    });
  });
  return routes;
};

export const fetchUserPermissions = async (roleId) => {
  const { data } = await axios.get(`roles/role/${roleId}`);
  return data.permissions || [];
};

export const getDefaultRoute = async (roleId) => {
  try {
    const permissions = await fetchUserPermissions(roleId);
    const routes = getPermittedRoutes(permissions);
    if (routes.includes(DASHBOARD_NAV.to)) return DASHBOARD_NAV.to;
    if (routes.includes('/oga-app/lines-company')) return '/oga-app/lines-company';
    return routes[0] || null;
  } catch (error) {
    console.error('Error fetching default route:', error);
    return null;
  }
};
